import React from 'react';

import { FilterTypes } from '@candu-ai/analytics/search';
import { QueryId, QueryParamUrlObject } from '@candu-ai/analytics/types';
import { CollapsableTable } from '@candu-ai/analytics/ui';
import { ACTION_COLUMN } from 'canoe/components/Table/types';
import { getLocalisedNumber } from 'commons/utils';
import { TableLink } from 'dashboard/components/TableLinks';
import { userAnalyticsPath } from 'dashboard/pages/Analytics/constants';

import { TableFilterActions } from './TableFilterActions';

interface Props {
  queryParams: QueryParamUrlObject;
}

const columns = [
  {
    key: 'userId',
    title: 'User Id',
    colSpan: 2,
    render: (name: string, record: any) => {
      return <TableLink text={name} link={`${userAnalyticsPath(record.userId)}`} />;
    },
  },
  {
    key: 'userEmail',
    title: 'Email',
    render: (name: string, record: any) => {
      return <TableLink text={name} link={`${userAnalyticsPath(record.userId)}`} />;
    },
    colSpan: 4,
  },
  {
    key: 'interactionLabel',
    title: 'Interaction',
    colSpan: 4,
  },
  {
    key: 'interactions',
    title: 'Total',
    render: (value: number) => getLocalisedNumber(value, 'en-US'),
  },
  {
    key: ACTION_COLUMN,
    title: 'actions',
    render: (text: string, record: any) => {
      if (record.userEmail) {
        return <TableFilterActions filterType={FilterTypes.UserEmail} value={record.userEmail} />;
      }

      return <TableFilterActions filterType={FilterTypes.UserId} value={record.userId} />;
    },
  },
];

export const InteractionsByUserTable = ({ queryParams }: Props) => (
  <CollapsableTable
    queryId={QueryId.InteractionsByUserTable}
    label="Interactions by User"
    queryParams={queryParams}
    columns={columns}
  />
);
